import React from 'react';
import { rem } from '@triumph/design-system';
import {
  WidgetContainer,
  SkeletonBlock,
  SkeletonContainer,
  SkeletonHeaderRow,
  SkeletonSubtitle,
  SkeletonSummary,
  SkeletonLegendRow,
  SkeletonTableSection,
  SkeletonTableRow,
  ICON_SIZE,
} from './CreditUtilizationWidget.StyledComponents';

export const CreditUtilizationSkeleton: React.FC = () => {
  return (
    <WidgetContainer>
      <SkeletonContainer>
        <SkeletonHeaderRow>
          <SkeletonBlock width={ICON_SIZE} height={ICON_SIZE} />
          <SkeletonBlock width="60%" height={rem(20)} />
        </SkeletonHeaderRow>
        <SkeletonSubtitle>
          <SkeletonBlock width="50%" height={rem(14)} />
        </SkeletonSubtitle>
      </SkeletonContainer>
      <SkeletonSummary>
        <SkeletonBlock width="50%" height={rem(22)} />
        <SkeletonBlock width="100%" height={rem(8)} />
        <SkeletonLegendRow>
          <SkeletonBlock width={rem(90)} height={rem(14)} />
          <SkeletonBlock width={rem(100)} height={rem(14)} />
        </SkeletonLegendRow>
      </SkeletonSummary>
      <SkeletonBlock width="100%" height={rem(36)} />
      <SkeletonTableSection>
        {[...Array(4)].map((_, i) => (
          <SkeletonTableRow key={i}>
            <SkeletonBlock width="60%" height={rem(16)} />
            <SkeletonBlock width={rem(36)} height={rem(16)} />
          </SkeletonTableRow>
        ))}
      </SkeletonTableSection>
    </WidgetContainer>
  );
};